import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { RiamComponent } from "../pages/riam/riam.component";
import { StepPreQualificationComponent } from "../pages/step-pre-qualification/step-pre-qualification.component";
import { SetCcpaParamGuard } from "./set-ccpa-param.guard";

const routes: Routes = [
  { path: "pre-qualification", component: StepPreQualificationComponent, canActivate: [SetCcpaParamGuard] },
  { path: "riam", component: RiamComponent },
  { path: "**", redirectTo: "pre-qualification", pathMatch: "full" }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { initialNavigation: "enabledBlocking" })],
  exports: [RouterModule],
  providers: [SetCcpaParamGuard]
})
export class RoutesModule {}
